import { IMPRESSION_ACTIONS, SCREEN_NAME } from "@cart-client/analytics/constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

export const impressionTimerOnCartEvent = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    timerContext?: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_TIMER_ON_CART,
        context: timerContext || "",
    });
};
